import Text from 'components/Text/Text';
import Mcc from './components/Mcc/Mcc';
import React, { useContext } from 'react';
import { RequestEntity } from 'types';
import NameField from './components/NameField';
import EmailField from './components/EmailField';
import EmailBodyTemplateField from './components/EmailBodyTemplateField';
import { ClientTypeSelect } from './components/ClientTypeSelect';
import BillTemplateDownloader from './components/BillTemplateDownloader';
import PriceTypeField from './components/PriceTypeField';
import DefaultLanguageField from './components/DefaultLanguageField';
import LanguagesField from './components/LanguagesField';
import Tips0Field from './components/Tips0Field';
import Tips1Field from './components/Tips1Field';
import Tips2Field from './components/Tips2Field';
import Tips3Field from './components/Tips3Field';
import { ShowLoyaltyProgramButtonsField } from './components/ShowLoyaltyProgramButtonsField';
import Tags from './components/Tags/Tags';
import { VivaWalletCredentialsField } from './components/VivaWalletCredentialsField';
import AdsField from './components/AdsField';
import MenuVersionField from './components/MenuVersionField';
import ContentVersionField from './components/ContentVersionField';
import { MixpanelTokenField } from './components/MixpanelTokenField';
import { StopListSyncIntervalField } from './components/StopListSyncIntervalField';
import CreatedField from './components/CreatedField';
import UpdatedField from './components/UpdatedField';
import RestaurantsDropdown from './components/RestaurantsDropdown';
import { ActivateBPAField } from './components/ActivateBPAField';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../customerFullInfoState/customerFullInfoContext';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import style from './MainInfoTab.module.scss';

export const MainInfoTab: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const superUserAccess = useRoleAccess([UserRoles.SUPER_USER]);

	return (
		<div className={style.container} data-test="MainInfoTab">
			<div className={style.imageBlock}>
				{customerForFullInfo?.filePath ? (
					<ImgUploaderByEntityId
						resource={RequestEntity.Customers}
						entityID={customerForFullInfo.id}
						photoSize="Medium"
						loaderSize="big"
						noImageIdIcon="customerDefaultAvatar"
						key="1"
					/>
				) : (
					<ImgUploaderByEntityId
						resource={RequestEntity.Customers}
						entityID="" // for show noImageIcon
						photoSize="Medium"
						loaderSize="big"
						noImageIdIcon="customerDefaultAvatar"
						key="2"
					/>
				)}
			</div>
			<div className={style.fieldsBLock}>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<div className={style.row}>
						<NameField />
						<EmailField />
					</div>
					<div className={style.row}>
						<EmailBodyTemplateField />
						<ClientTypeSelect />
					</div>
					<BillTemplateDownloader />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="priceTypeHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<PriceTypeField />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="languagesHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<div className={style.row}>
						<DefaultLanguageField />
						<LanguagesField />
					</div>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="loyaltyProgramHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<ShowLoyaltyProgramButtonsField />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mccHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<Mcc />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="tipsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<div className={style.row}>
						<Tips0Field />
						<Tips1Field />
					</div>
					<div className={style.row}>
						<Tips2Field />
						<Tips3Field />
					</div>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="tagsForSearchInMenuHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					{customerForFullInfo?.tags.length ? (
						<Tags />
					) : (
						<Text
							className={style.requiredLabel}
							translationNameSpace="form"
							translationKey="noTagsHeading"
							theme="secondary"
							size="m"
							weight="bold"
							display="inline"
						/>
					)}
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="credentialsNameHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<VivaWalletCredentialsField />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="adsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<AdsField />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="menuContentVersionHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<div className={style.row}>
						<MenuVersionField />
						<ContentVersionField />
					</div>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mixpanelHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<MixpanelTokenField />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="createHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<div className={style.row}>
						<CreatedField />
						<UpdatedField />
					</div>
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantsHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<RestaurantsDropdown />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="enableStopListHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<StopListSyncIntervalField />
				</div>
				{superUserAccess && (
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="bpaHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<Text
							translationNameSpace="form"
							translationKey="BPAIsUsedOnlyByThoseUsersWhoHaveEnteredIntoAgreementToWorkUnderBPAScheme"
							size="xs"
							theme="neutralLight"
						/>
						<ActivateBPAField />
					</div>
				)}
			</div>
		</div>
	);
};
